/* Gallery video: always silent, and plays only while on screen.

   Muting is enforced rather than merely set, because a browser extension, a
   long-press menu or a stray script can unmute a video after it starts. Every
   video on the page is held muted for as long as it exists. */
(function () {
  const silence = (video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.removeAttribute('controls');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('disablepictureinpicture', '');
    video.setAttribute('disableremoteplayback', '');
  };

  const watch = (video) => {
    silence(video);
    // Videos marked data-manual are started by their own section, not here
    if (video.hasAttribute('data-manual')) {
      video.addEventListener('volumechange', () => { if (!video.muted || video.volume > 0) silence(video); });
      return;
    }
    // If anything turns the sound on, turn it straight back off
    video.addEventListener('volumechange', () => {
      if (!video.muted || video.volume > 0) silence(video);
    });
    video.play?.().catch(() => {});

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? video.play?.().catch(() => {}) : video.pause?.()));
      }, { threshold: 0.25 }).observe(video);
    }
  };

  const start = () => {
    document.querySelectorAll('video').forEach(watch);
    // Videos added later, for example by a quick view or a recommendation block
    if ('MutationObserver' in window) {
      new MutationObserver((records) => {
        records.forEach((r) => r.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'VIDEO') watch(n);
          else n.querySelectorAll?.('video').forEach(watch);
        }));
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();
})();
